export var MealPrepCategory;
(function (MealPrepCategory) {
    MealPrepCategory["Soak"] = "SOAK";
    MealPrepCategory["Cut"] = "CUT";
    MealPrepCategory["Freeze"] = "FREEZE";
    MealPrepCategory["Cook"] = "COOK";
    MealPrepCategory["Blend"] = "BLEND";
    MealPrepCategory["Fridge"] = "FRIDGE";
    MealPrepCategory["Generic"] = "GENERIC";
})(MealPrepCategory || (MealPrepCategory = {}));
